module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "site-footer"
  }, [_c('div', {
    staticClass: "nav-footer"
  }, [_c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('')
    }
  }, [_vm._v("หน้าแรก")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('our-work')
    }
  }, [_vm._v("งานของเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('about')
    }
  }, [_vm._v("เกี่ยวกับเรา")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('good-governance')
    }
  }, [_vm._v("ธรรมาภิบาล")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('news-media')
    }
  }, [_vm._v("ข่าวสาร")])]), _vm._v(" "), _c('li', {
    staticClass: "menu-item"
  }, [_c('a', {
    attrs: {
      "href": _vm.$utils.getWpPath('take-action')
    }
  }, [_vm._v("ร่วมร้อยพลัง")])])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom-footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('img', {
    staticClass: "fl-left logo-footer",
    attrs: {
      "src": require("../assets/domain-custom/base/logo-domain.png"),
      "srcset": ((require('../assets/domain-custom/base/logo-domain.png')) + " 1x, " + (require('../assets/domain-custom/base/logo-domain@2x.png')) + " 2x"),
      "alt": "LOGO TCFE"
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('strong', [_vm._v("ติดต่อ – สอบถามข้อมูลเพิ่มเติม")]), _c('br'), _vm._v("\n        โครงการร้อยพลังเปลี่ยนประเทศ มูลนิธิเพื่อคนไทย"), _c('br'), _vm._v("\n        อีเมล: tcfe@ktf.premier.co.th"), _c('br'), _vm._v("\n        โทรศัพท์: 02 301 1000 ต่อ 1117 / 02 301 1117\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "social-footer"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('strong', [_vm._v("สอบถามรายละเอียด หรือรับข่าวสารผ่านช่องทางของเรา")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticStyle: {
      "flex": "1",
      "margin-right": "10px",
      "text-align": "center"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://line.me/ti/p/%40TCFE"
    }
  }, [_c('img', {
    staticClass: "wp-image-1436 alignnone",
    staticStyle: {
      "margin-bottom": "0 !important"
    },
    attrs: {
      "src": require("../assets/img/icon/line-add@2x.png"),
      "alt": "",
      "width": "196",
      "height": "53"
    }
  }), _c('span', {
    staticStyle: {
      "text-align": "center",
      "display": "inline-block",
      "font-size": "13px"
    }
  }, [_vm._v("LINE ID: @TCFE")])])]), _c('div', {
    staticStyle: {
      "flex": "1"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://web.facebook.com/ThailandCollaborationForEducation/",
      "target": "blank"
    }
  }, [_c('img', {
    staticClass: "wp-image-1434 alignnone",
    attrs: {
      "src": require("../assets/img/icon/facebook-page@2x.png"),
      "alt": "",
      "width": "196",
      "height": "53"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07546f83","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
// module id = 1111
// module chunks = 0